// CODE CREDITTED TO MOSTAFA
import styled from '@emotion/styled'
import { Modal, ModalHeader } from 'react-bootstrap'
import { ReactComponent as ExternalLink } from '../../assets/svgs/boxArrowUpRight.svg'
import { ReactComponent as Copy } from '../../assets/svgs/copy.svg'
import { ReactComponent as Briefcase } from '../../assets/svgs/briefcase.svg'
import { ReactComponent as ChevronUp } from '../../assets/svgs/chevronUp.svg'
import { ReactComponent as ChevronDown } from '../../assets/svgs/chevronDown.svg'
import { ReactComponent as Clock } from '../../assets/svgs/clock.svg'
import { ReactComponent as Calendar } from '../../assets/svgs/calendar.svg'
import { ReactComponent as User } from '../../assets/svgs/user.svg'
import { ReactComponent as ExclamationCircleEmpty } from '../../assets/svgs/exclamationCircle.svg'
import { ReactComponent as RightArrow } from '../../assets/svgs/arrow-right.svg'

export const StyledModal = styled(Modal)(() => ({
  '.modal-content': {
    borderRadius: '12px',
    border: 'none',
    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
  },
  '.modal-header': {
    borderBottom: '1px solid #e9ecef',
    paddingBottom: '1rem',
  },
  '.modal-title': {
    fontWeight: '600',
    color: '#333',
  },
  '.modal-body': {
    padding: '1.5rem',
  },
  '.modal-footer': {
    borderTop: '1px solid #e9ecef',
    paddingTop: '1rem',
  },
}))

export const StyledConfirmationModal = styled(Modal)(() => ({
  minWidth: '379px',
  maxWidth: '600px',
  minHeight: '300px',
  position: 'fixed',
  display: 'flex',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 1060,
}))

export const StyledModalBody = styled(Modal.Body)(({ height = 'auto' }) => ({
  height,
  position: 'relative',
  overflowY: 'auto',
  overflowX: 'hidden',
}))

export const StyledContentWrapper = styled('div')(
  ({ maxHeight = '100px' }) => ({
    overflowY: 'auto',
    maxHeight,
  }),
)

// //////////////////// Move to stage modal /////////////////////

export const CustomModal = styled(Modal)(() => ({
  '.modal-dialog': {
    maxWidth: '600px',
  },
  '.modal-content': {
    borderRadius: '6px',
    border: 'none',
  },
  '.modal-header': {
    border: 'none',
    zIndex: 1050,
  },
  '.modal-body': {
    padding: '0',
  },
  '.modal-footer': {
    border: 'none',
  },
}))

export const CustomModalHeader = styled(ModalHeader)(() => ({
  marginBottom: '-3rem',
}))

// TODO: to be refactored (CODE CREDITTED TO MOSTAFA)
export const StyledRenderEvent = styled.section((props) => ({
  backgroundColor: props.backgroundColor,
  borderRadius: '5px',
  padding: '5px',
}))

export const CalendarBody = styled.section(({ theme }) => ({
  '.fc-daygrid-day, .fc-timegrid-col-header, .fc-daygrid-day-number': {
    fontSize: '14px',
    color: `${theme.ateneoBlue}`,
  },
  '.fc-toolbar-title': {
    fontSize: '16px',
    color: `${theme.ateneoBlue}`,
  },
  a: {
    textDecoration: 'none',
  },
  '.fc-col-header-cell-cushion, .fc-list-day-text, .fc-list-day-side-text, .fc-list-event-time':
    {
      color: `${theme.ateneoBlue}`,
      fontSize: '14px',
    },
  '.fc-button, .fc-scrollgrid-shrink-cushion, .css-1or5cvv': {
    fontSize: '14px',
  },
  '.fc-scrollgrid-shrink-cushion': {
    color: `${theme.ateneoBlue}`,
  },
  '.fc-button-primary': {
    backgroundColor: `${theme.ateneoBlue}`,
  },
  '.fc-button-primary:hover, .fc-button-active': {
    backgroundColor: 'rgba(5, 48, 101, 0.8) !important',
  },
  '.fc-today-button': {
    backgroundColor: 'rgba(5, 48, 101) !important',
  },
  '.fc-day-today': {
    backgroundColor: 'rgba(173, 216, 230, 0.2) !important',
  },
  '.fc-timegrid-event': {
    border: 'none !important',
    borderRadius: '0.25rem',
    margin: '0 !important',
    padding: '0 !important',
    backgroundColor: 'transparent !important',
    '&[data-event-id^="recurring-"]': {
      width: '100% !important',
    },
  },
  '.fc-daygrid-event': {
    border: 'none !important',
    borderRadius: '0.25rem',
    margin: '0 !important',
    width: '100%',
    padding: '0 !important',
    backgroundColor: 'transparent !important',
    '.fc-event-main': {
      width: '100%',
    },
  },
  '.fc-daygrid-event-harness': {
    '&[data-event-id*="-child"]': {
      paddingLeft: '8px',
      width: 'calc(100% - 8px) !important',
    },
  },
  '.fc-daygrid-day-events': {
    border: 'none !important',
    borderRadius: '0.25rem',
    padding: '0 !important',
    backgroundColor: 'transparent !important',
  },
  '.fc-event-main': {
    border: 'none !important',
    borderRadius: '0.25rem',
    padding: '0 !important',
    backgroundColor: 'transparent !important',
  },
  '.fc-h-event': {
    display: 'block',
    backgroundColor: 'transparent !important',
    borderColor: 'transparent !important',
  },
}))

export const LinksContainer = styled.div({
  marginTop: '1rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
})

export const StyledLink = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontSize: '0.9rem',
  strong: {
    fontWeight: 600,
    color: '#333',
  },
})

export const IconWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  svg: {
    cursor: 'pointer',
    width: '18px',
    height: '18px',
    fill: '#6c757d',
    transition: 'fill 0.2s ease',
    '&:hover': {
      fill: '#0d6efd',
    },
  },
})

export const Container = styled.div({
  margin: '0 auto',
})

export const Card = styled.div({
  background: '#ffffff',
  borderRadius: '0.5rem',
  boxShadow:
    '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)',
  overflow: 'hidden',
})

export const Header = styled.div(({ theme }) => ({
  padding: '0.8rem',
  borderLeft: `4px solid ${theme.headersMiniTitle}`,
  cursor: 'pointer',
  transition: 'background-color 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: '#f9fafb',
  },
}))

export const HeaderRow = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
})

export const LeftSection = styled.div({
  flex: 1,
})

export const IconGroup = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
})

export const Title = styled.h2({
  fontSize: '1.125rem',
  margin: 0,
  fontWeight: 600,
  color: '#1f2937',
})

export const DateTimeRow = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  marginTop: '0.5rem',
  color: '#4b5563',
})

export const DateTimeItem = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '0.25rem',
})

export const DetailsPanel = styled.div({
  padding: '1.5rem',
  background: '#f9fafb',
  borderTop: '1px solid #f3f4f6',
})

export const CandidateDetails = styled.div({
  '& > * + *': {
    marginTop: '1rem',
  },
})

export const CandidateHeader = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
})

export const CandidateName = styled.h3({
  fontSize: '1rem',
  margin: 0,
  fontWeight: 500,
  color: '#374151',
})

export const InterviewLinks = styled.div({
  marginTop: '1.5rem',
  '& > * + *': {
    marginTop: '0.75rem',
  },
})

export const InterviewLinkItem = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '0.75rem',
  background: '#ffffff',
  borderRadius: '0.5rem',
  boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
})

export const LinkLabel = styled.span({
  fontSize: '0.875rem',
  fontWeight: 500,
  color: '#374151',
})

export const LinkActions = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
})

export const IconButtonLink = styled.a({
  padding: '0.5rem',
  borderRadius: '9999px',
  transition: 'background-color 0.2s ease-in-out',
  '&:hover': {
    backgroundColor: '#f3f4f6',
  },
})

export const IconButton = styled.button({
  padding: '0.5rem',
  border: 'none',
  background: 'transparent',
  borderRadius: '9999px',
  transition: 'background-color 0.2s ease-in-out',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#f3f4f6',
  },
})

export const ActionButtonContainer = styled.div({
  marginTop: '1.5rem',
  display: 'flex',
  justifyContent: 'flex-end',
})

export const ActionButton = styled.a(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  padding: '0.5rem 1rem',
  background: theme.headersMiniTitle,
  color: '#ffffff',
  borderRadius: '0.5rem',
  transition: 'background-color 0.2s ease-in-out',
  textDecoration: 'none',
  '&:hover': {
    background: theme.brandColorOrange,
  },
}))

export const StyledBriefcase = styled(Briefcase)(({ theme }) => ({
  width: '1.25rem',
  height: '1.25rem',
  color: theme.headersMiniTitle,
}))

export const StyledChevronUp = styled(ChevronUp)({
  width: '1.5rem',
  height: '1.5rem',
  color: '#9ca3af',
})

export const StyledChevronDown = styled(ChevronDown)({
  width: '1.5rem',
  height: '1.5rem',
  color: '#9ca3af',
})

export const StyledCalendar = styled(Calendar)({
  width: '1rem',
  height: '1rem',
})

export const StyledClock = styled(Clock)({
  width: '1rem',
  height: '1rem',
})

export const StyledUser = styled(User)(({ theme }) => ({
  width: '1.25rem',
  height: '1.25rem',
  color: theme.headersMiniTitle,
}))

export const StyledExternalLink = styled(ExternalLink)(({ theme }) => ({
  width: '1rem',
  height: '1rem',
  color: theme.headersMiniTitle,
}))

export const StyledCopy = styled(Copy)({
  width: '1rem',
  height: '1rem',
  color: '#4b5563',
})

export const NotesItem = styled.div(() => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '1rem',
  padding: '0.75rem',
  borderRadius: '0.5rem',
  border: '1px solid',
  borderColor: '#e5e7eb',
  backgroundColor: '#f8f8f8',
  transition: 'all 0.2s',
  '&:hover': {
    boxShadow: '0 8px 12px rgba(0, 0, 0, 0.15)',
    transform: 'scale(1.015)',
    borderColor: '#e5e7eb',
    backgroundColor: '#f6f6f6',
  },
  '@media (min-width: 640px)': {
    gap: '1.5rem',
    padding: '1rem',
  },
}))

// swithing company modal

export const StyledModalDialog = styled(Modal.Dialog)(
  ({ modalDisplayType }) => ({
    display: modalDisplayType,
    position: 'fixed',
    top: '20%',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '600px',
    borderRadius: '10px',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    border: 'none',
    backgroundColor: '#FFFFFF',
    zIndex: '20',
  }),
)

export const StyledExclamationCircle = styled(ExclamationCircleEmpty)(
  ({ theme }) => ({
    width: '60px',
    height: '60px',
    color: theme.brandColorLightOrange,
    marginTop: '20px',
    marginBottom: '20px',
  }),
)

export const DeleteExclamationCircle = styled(ExclamationCircleEmpty)({
  width: '35px',
  height: '35px',
})

export const StyledRightArrow = styled(RightArrow)({
  width: '50px',
  height: '50px',
  marginBottom: '20px',
  marginRight: '30px',
  marginLeft: '30px',
})

export const ContentContainer = styled('div')({
  fontSize: '18px',
  fontWeight: '500',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
})

export const CompanyInfoContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '1rem',
})

export const CompanyDetails = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '1.2rem',
  fontSize: '1.2rem',
})

export const BlurredBackground = styled('div')(({ modalDisplayType }) => ({
  display: modalDisplayType,
  position: 'fixed',
  top: '0',
  left: '0',
  width: '100vw',
  height: '100vh',
  zIndex: '10',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  backdropFilter: 'blur(10px)',
  WebkitBackdropFilter: 'blur(10px)',
}))
